var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Strokes",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b {\n        fill: #FDB81B;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.47,15.63c-.12,0-.24-.03-.35-.09l-4.12-2.17-4.12,2.17c-.25.13-.56.11-.79-.06s-.35-.45-.3-.73l.79-4.59L.24,6.91c-.2-.2-.28-.5-.19-.77.09-.27.32-.47.61-.51l4.61-.67L7.33.79c.25-.51,1.09-.51,1.34,0l2.06,4.17,4.61.67c.28.04.52.24.61.51.09.27.01.57-.19.77l-3.33,3.25.79,4.59c.05.28-.07.57-.3.73-.13.09-.29.14-.44.14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon-star.a0aa058e426245d76855314d116b93cc.svg";
export { ForwardRef as ReactComponent };